import React from 'react';
import cls from '@utils/css-select';
import Slider, { Settings } from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from './styles.scss';
const cx = cls(styles);

const NoticeIcon = 'https://web-data.zmlearn.com/image/5DP3b5aKRJpoYoLmWiNeTa/notice%402x.png';
const list = [
	`79******35     success！         1 min ago`,
	`75******36     success！         1 min ago`,
	`77******16     success！         2 mins ago`,
	`79******80     success！         2 mins ago`,
	`77******92     success！         5 mins ago`,
	`78******23     success！         5 mins ago`,
	`78******04     success！         10 mins ago`,
	`79******81     success！         10 mins ago`,
	`78******47     success！         10 mins ago`,
	`77******63     success！         10 mins ago`,
];
export default function RollingText() {
	// const { className, children, ...settings } = props;
	return (
		<div className={cx('rolling-text')}>
			<div className={cx('notice-icon')}>
				<img src={NoticeIcon} alt='' />
			</div>
			<Slider
				autoplay
				touchMove={false}
				vertical
				infinite
				arrows={false}
				autoplaySpeed={1500}
				// {...settings}
			>
				{list.map(item => <div key={item} className={cx('rolling-item')}>{item}</div>)}
			</Slider>
		</div>
	)
}
